export const style = {
  wrapper: {
    marginTop: `60px`
  },
  box: {
    border: `#ddd 1px solid`,
    paddingTop: `20px`,
    paddingBottom: `20px`,
    marginTop: `15px`,
    'media only screen and (min-width: 768px)': {
      marginTop: `60px`
    }
  },
  number: {
    color: `#A94545`,
    fontSize: `50px`,
    fontWeight: `400`,
    textAlign: `center`
  },
  desc: {
    color: `#666`,
    fontSize: `17px`,
    fontWeight: `300`,
    lineHeight: `22px`,
    paddingTop: `6px`,
    textAlign: `center`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Home/style/stats.js